// src/store/Bulletin/bulletinActions.js

import * as actionTypes from "../ActionTypes";

// 🔹 Save Bulletin
export const saveBulletinRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_BULLETIN_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});
export const saveBulletinSuccess = (data) => ({
  type: actionTypes.SAVE_BULLETIN_SUCCESS,
  payload: data,
});
export const saveBulletinFailure = (error) => ({
  type: actionTypes.SAVE_BULLETIN_FAILURE,
  payload: error,
});

// 🔹 Update Bulletin
export const updateBulletinRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_BULLETIN_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});
export const updateBulletinSuccess = (data) => ({
  type: actionTypes.UPDATE_BULLETIN_SUCCESS,
  payload: data,
});
export const updateBulletinFailure = (error) => ({
  type: actionTypes.UPDATE_BULLETIN_FAILURE,
  payload: error,
});

// 🔹 Delete Bulletin
export const deleteBulletinRequest = (payload, callback) => ({
  type: actionTypes.DELETE_BULLETIN_REQUEST,
  payload,
  callback,
});
export const deleteBulletinSuccess = (data) => ({
  type: actionTypes.DELETE_BULLETIN_SUCCESS,
  payload: data,
});
export const deleteBulletinFailure = (error) => ({
  type: actionTypes.DELETE_BULLETIN_FAILURE,
  payload: error,
});
